import { useState, useEffect } from 'react';
import { Bold, Flex } from './TremorCompat';
import { Button } from './TremorCompat';
import { Panel, Text } from 'rsuite';

import { COLOURS } from '../styles';
import { DisplayIcon } from './DisplayIcon';
import { devLog } from '../utils/devLog';

export const DisplayToggleButtonItem = ({ register, tc, icon, options, disabled, onChange, borderOff }) => {
  const [writeValue, setWriteValue] = useState(0);

  const updateValue = () => {
    devLog('Button Update Value', register, 'Options: ', options[writeValue].value);
    onChange(register, options[writeValue].value);
  };

  useEffect(() => {
    setWriteValue(register.value === 0 ? 1 : 0);
  }, [register.value]);

  return (
    <Panel bordered={!borderOff} style={{ backgroundColor: 'white' }}>
      <Flex justifyContent="start" className="space-x-4">
        <DisplayIcon icon={icon} />

        <div
          className="truncate w-1/2 space-y-1"
          style={{
            display: 'block',
            width: '50%',
          }}
        >
          <Text color={tc}>{register.title}</Text>
          <Text color={tc}>
            <Bold>{register.display}</Bold>
          </Text>
        </div>

        <div
          className="truncate w-1/2 space-y-1"
          style={{
            display: 'block',
            width: '50%',
          }}
        >
          <Flex justifyContent="end" className="space-x-4 ">
            <Button color={COLOURS.default} size="sm" disabled={disabled} onClick={updateValue}>
              {options[writeValue].label}
            </Button>
          </Flex>
        </div>
      </Flex>
    </Panel>
  );
};
